import {
    getRouteDowloandLoading,
    getRouteDowloandReject,
    getRouteDowloandRequest,
    getRouteDowloandSuccess
} from "../../actions/route/getAllDowloand";
import { exportToExcel } from "react-json-to-excel";

export const getRouteDowloand = (formData) => async (dispatch, getState) => {
    dispatch(getRouteDowloandLoading());
    try {
        const { data } = await getRouteDowloandRequest(formData, getState);
        dispatch(getRouteDowloandSuccess(data))
         exportToExcel(data.data.data, 'Rutas')
    } catch (error) {
        dispatch(getRouteDowloandReject(error))
    }
    return Promise.resolve();
};